module.exports = __webpack_public_path__ + "static/media/photo59.07d8fdf6.jpg";